export const types = {
    SET_CARD_OPERATION: '[PROVIDER] SET CARD OPERATION LIST',
    SET_GET_ALFAKIT_BALANCE: '[BALANCE] ALFAKIT BALANCE'
}